import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';
Vue.use(Vuetify)

const opts = {
  theme: {
    themes: {
      light: {
        'tool-bar-app': '#5492C1',
        'nav-bar': '#508fbf',
        'nav-bar-sub': '#5492C1',
        second: '#009688',
        accent: '#25848c',
        'table-head': '#2196f3',
        // 'table-hover': '#2497f326',

      }
    }

  }
}

export default new Vuetify(opts);
